import { parseNumericValue } from "../../../utils/common";
import { logger } from "../../../utils/logger";
// import { logger } from "../../../utils/logger";

export function calculationAllowanceAmount({
  allowanceList = [],
  basicSalaray = 0,
}) {
  return parseNumericValue(allowanceList.reduce((prev, curr) => {
    let amount = 0;


    if (curr?.isChecked) {

      if (curr?.allowanceType === "fixed") {
        amount = parseNumericValue(curr?.allowanceValue);
      } else {
        amount = basicSalaray * (parseNumericValue(curr?.allowanceValue) / 100);
      }
    }

    return prev + amount;
  }, 0));
}
export function calculationAllowanceInfo({
  allowanceList = [],
  basicSalaray = 0,
}) {


  let allAllowanceSum = 0;
  let checkedAllowancesSum = 0;
  let epfCoveredAllowancesSum = 0;
  let esiCoveredAllowancesSum = 0;
  let grossIncludedCheckedAllowanceSum = 0;

  allowanceList.reduce((prev, curr) => {
    let amount = 0;



    if (curr?.allowanceType === "fixed") {
      amount = parseNumericValue(curr?.allowanceValue);
    } else {

      amount = basicSalaray * (parseNumericValue(curr?.allowanceValue) / 100);

    }
    allAllowanceSum += amount;
    if (curr?.isChecked) {
      checkedAllowancesSum += amount;
      if (curr?.isEpfWages && curr?.addToGross) {
        epfCoveredAllowancesSum += amount;
        
      }
      if (curr?.isEsiWages && curr?.addToGross) {
        esiCoveredAllowancesSum += amount;
      }
      if (curr?.addToGross) {
        grossIncludedCheckedAllowanceSum += amount;
      }
    }


  }, 0);


  return {
    allAllowanceSum,
    checkedAllowancesSum,
    epfCoveredAllowancesSum,
    esiCoveredAllowancesSum,
    grossIncludedCheckedAllowanceSum
  }
}


//Allowance Adjustment calculation


export function calculatePerformance({
  hasEmployerContibutionIncludeInCTC,
  CTC,
  contribution15K,
  basicAndCheckedAllowanceSum,

  isPerformanceEPFCoverd,
  epfCoveredWages,
  esiCoveredWages,
  epfEsiEligibalePercentage = "12%",
  epf_availability,
  esi_availability,
  // isIncludeEPF,
  isIncludeAdminCharge,
  isIncludeESICharge
}) {


  const D1 = Number(parseNumericValue(CTC));
  const D2 = contribution15K;
  let D3 = 0;
  const D5 = 3.25;
  const G13 = Number(parseNumericValue(epfCoveredWages));
  const H13 = Number(parseNumericValue(esiCoveredWages));
  const E13 = Number(parseNumericValue(basicAndCheckedAllowanceSum));
  // const D3 =epfEsiEligibalePercentage ==="12%" ? 13:11;
  // const D3 =epfEsiEligibale ? 13:0;

  if(epfEsiEligibalePercentage ==="12%" ){
    D3 = isIncludeAdminCharge ? 13:12
  }else{
    D3 = isIncludeAdminCharge ? 11:10
  }
  // logger.log(D5+"ppsesi"+H13);
  const B14 = isPerformanceEPFCoverd;
  const wageLimit = 15000;
  const EsiLimit = 21000;
  const DueAmount = D1 - E13;
  const Epfpercentage = D3 / 100;
  const EsiPercentage = D5 / 100;
  // const percentage = B14 ?( D3 + D5 + 100) : ( D5 + 100);
  // const EpfWage =  (D2 && G13 > wageLimit) ? wageLimit : G13;
  // const EpfValue = EpfWage * Epfpercentage ;
  const EsiValue = H13 * EsiPercentage ;


  const EpfOtherAmmount =(D2 && G13 > wageLimit)
  ? DueAmount - (wageLimit * Epfpercentage)
  :B14?
    (((DueAmount - (G13 * Epfpercentage) ) * 100)/(D3+100)) + G13 > wageLimit
      ?DueAmount - (wageLimit * Epfpercentage)
      :((DueAmount - (G13 * Epfpercentage) ) * 100)/(D3+100)
    :(DueAmount - (G13 * Epfpercentage))
  
  const EsiOtherAmmount = (((DueAmount - EsiValue ) * 100)/(D5+100)) + H13 <= EsiLimit
    ? ((DueAmount - EsiValue ) * 100)/(D5+100)
    : DueAmount
  
  const EsiEpfOtherAmmount =  (D2 && G13 > wageLimit)
   ?((DueAmount - (wageLimit * Epfpercentage)-(EsiValue)) * 100)/(D5+100)
   :B14?
     (((DueAmount - (G13 * Epfpercentage) - (EsiValue)) * 100)/(D3+D5+100)) + G13 > wageLimit 
        ? ((DueAmount - (wageLimit * Epfpercentage)-(EsiValue)) * 100)/(D5+100)
        : ((DueAmount - (G13 * Epfpercentage) - (EsiValue)) * 100)/(D3+D5+100)
     :((DueAmount - (G13 * Epfpercentage) - (EsiValue)) * 100)/(D5+100)
  ; 
  const EpfAllow = epf_availability && hasEmployerContibutionIncludeInCTC;  // or undefined/false
  const EsiAllow = esi_availability && isIncludeESICharge; // or undefined/false
  let result;
  
  if (EpfAllow && EsiAllow) {
    // logger.log("Both EpfAllow and EsiAllow are true PPS= "+EsiEpfOtherAmmount);
    result = EsiEpfOtherAmmount + H13 <= EsiLimit ? EsiEpfOtherAmmount : EpfOtherAmmount;
  } else if (EpfAllow && !EsiAllow) {
    // logger.log("EpfAllow is true and EsiAllow is false PPS");
    result = EpfOtherAmmount;
  } else if (!EpfAllow && EsiAllow) {
    // logger.log("EpfAllow is false and EsiAllow is true PPS");
    result = EsiOtherAmmount
  } else {
    // logger.log("Both EpfAllow and EsiAllow are false PPS");
    result = DueAmount;
  }
 


  // if (!hasEmployerContibutionIncludeInCTC || !epf_availability) {
  //   result = DueAmount;
  // } else {
  //   if (D2 && G13 > wageLimit) {
  //     result = D1 - E13 - (wageLimit * percentage);
  //   } else if (B14) {
  //     result = ((D1 - E13 - (G13 * percentage)) * 100) / (D3 + 100);
  //   } else {
  //     result = D1 - E13 - (G13 * percentage);
  //   }
  // }

  return result;
}

//Employer contribution  calculation




export function calculateEmployerContributionEsi(
  { esiElibiable,
    totalESIWagesAmount,
    rate = 0, 
  }
) {
  rate = 3.25;
  const EsiLimit = 21000;
  const companyContributionRate = rate / 100; 

  if (!esiElibiable  && totalESIWagesAmount > EsiLimit) {
    return 0;
  } else {
    return parseNumericValue(totalESIWagesAmount) * companyContributionRate;
  }
  
}

export function calculateEmployerContributionEPF(
  { isEpfEgiliable,
    PF_WAGES,
    contribution15K,
    rate = 0, 
    epfEsiEligibalePercentage,
    isIncludeAdminCharge
  }
) {

  if(epfEsiEligibalePercentage ==="12%" ){
    rate = isIncludeAdminCharge ? 13:12
  }else{
    rate = isIncludeAdminCharge ? 11:10
  }
  const wageLimit = 15000;
  const companyContributionRate = rate / 100; // Fixed 13% contribution rate
  logger.log(PF_WAGES+ "pps")
  if (!isEpfEgiliable) {
    return 0;
  }else if (contribution15K && parseNumericValue(PF_WAGES) > wageLimit) {
    return wageLimit * companyContributionRate;
  } else {
    return parseNumericValue(PF_WAGES) * companyContributionRate;
  }


  
  // if (parseNumericValue(PF_WAGES) > 15000) {
  //   if (contribution15K) {
  //     return 15000 * companyContributionRate;
  //   } else {
  //     return parseNumericValue(PF_WAGES) * companyContributionRate;
  //   }
  // } else {
  //   return PF_WAGES * companyContributionRate;
  // }
  
}